import { Row, Col } from 'react-bootstrap'
import SearchInput from './searchInput';
import { useLocation } from 'react-router-dom';
import Tooltip from './tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ActionBar = ({ children, searchChange = () => {}, title = "", showSearchBar = true, showSearchInput = true, pageDescription = "", icon = null}) => {
  const { pathname } = useLocation();

  return (
    <div id="action-bar" className="p-3 pt-5" data-testid="action-bar">
      <Row className="justify-content-between">
        <Col sm="auto">
          { pathname === '/ssid-whitelist' 
            ? <Tooltip customClass={'ssid-whitelist-tooltip'} placement="right-start" id="wifi-ssid-tooltip" content="SafeCase will automatically enter Checked-In/Secure Mode and enforce policy when it detects that the phone it protects is connected to any SSID on an assigned list.">
                <h1 id="h1" data-testid="action-bar-title" className="d-inline me-3 pointer">{title}</h1>
              </Tooltip>
            : <h1 id="h1" data-testid="action-bar-title" className="d-inline me-3">{title} {icon && <FontAwesomeIcon icon={icon} className="ms-3" />}</h1>
          }
        </Col>
        {showSearchBar &&
          <Col sm="auto" className="action-buttons">
            <Row className="align-items-end">
              <Col>
                {showSearchInput && 
                  <SearchInput onChange={searchChange} />
                }
                {children}
              </Col>
            </Row>
          </Col>
        }
      </Row>

      {pageDescription &&
        <Row> 
          <Col>
            <p className="mt-3 mb-0">{pageDescription}</p>
          </Col>
        </Row>
      }
    </div>
  )
}

export default ActionBar
